export function splitGraphemes(str: string): string[] {
  // Prefer Intl.Segmenter if available (handles emoji/combining marks)
  // Fallback to Array.from which handles surrogate pairs reasonably
  // @ts-ignore
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    // @ts-ignore
    const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
    return Array.from(seg.segment(str), (s: any) => s.segment);
  }
  return Array.from(str);
}
